import { render } from "./doneFooter.vue?vue&type=template&id=1995d5b8"
import script from "./doneFooter.vue?vue&type=script&lang=js"
export * from "./doneFooter.vue?vue&type=script&lang=js"

import "./doneFooter.vue?vue&type=style&index=0&id=1995d5b8&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__